import { LcAddress } from "@/domains/core"

export const BIGINT_ZERO = BigInt(0)
export const ADDRESS_ZERO = "0x0000000000000000000000000000000000000000"
export const SAFE_ADDRESS_ZERO = "0x0000000000000000000000000000000000012345"
export const BIGINT_MAX_256 = BigInt("0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF")

// move away from chain config files to hard coded constants (soon to be .env vars)
export const RECYCLE_FUND_WALLET = new LcAddress("0x895BaAd10878205FC6112439274f9C84CD5a395F")
export const MINTER_ADDRESS = new LcAddress("0x44621CcEF14730A2F864eC11311A7F0BCB005685")
export const PROCESSING_REWARDS_WALLET = new LcAddress("0x7D970D34a041251a4500Fc4997C6f74104f16d23")
